import React from 'react'
import * as Styled from './styled'

const Cursor = () => {
    return <Styled.CursorWrapper />
}

export default Cursor
